import moment from "moment";

export const timestampToReadableDate = (timestamp: number = 0): string => {
  const createdAtString = timestamp.toString();
  return moment(parseInt(createdAtString, 10))
    .format("DD/MM/YYYY");
};
